import dayjs from 'dayjs'
import { useState } from 'react'
import { useView } from '@10000/react'
import { format } from '@10000/common'
import { Body, Box, Button, Download } from '../../widgets'
import { assetUrl } from '../../../utilities.js'
import { SettingsLayout } from '../'
import { UpdateCard } from './'

export const Billing = ({ goBackToSettingsMenu }) => {
  const { paymentMethod, invoices } = useView('tenant')
  const [editPayment, setEditPayment] = useState(false)

  return editPayment
    ? <UpdateCard onClose={() => setEditPayment(false)}/>
    : <SettingsLayout
        gap={32}
        title="Billing"
        backButtonMobileOnly
        onBackButtonClick={goBackToSettingsMenu}
      >
        {paymentMethod
          ? <Box border="solid black 1px" radius={16} fullWidth justifyContent="space-between" p={12}>
              <PaymentMethod paymentMethod={paymentMethod} />
            </Box>
          : <Body bold alt>No current payment method</Body>
        }
        <Button fullWidth onClick={() => setEditPayment(true)}>Update payment method</Button>

        <Box fullWidth column gap={8}>
          <Body alt bold>Invoices</Body>

          <Box border="solid black 1px" radius={16} p={8} column>
            {invoices.map((invoice, index) =>
              <Invoice key={index} invoice={invoice} index={index} />
            )}
          </Box>
        </Box>
      </SettingsLayout>
}

const PaymentMethod = ({ paymentMethod: { name, brand, last4, exp_month, exp_year } }) => (
  <Box fullWidth gap={4}>
    <img alt="Card brand" src={assetUrl(`${brand}.png`, 'paymentMethods')} />
    <Box column gap={4} justifyContent="center">
      <Body bold alt lineHeight="100%">{name}</Body>
      <Body>•••• •••• •••• {last4}</Body>
      <Body size={12} lineHeight="100%">Expiry {exp_month}/{exp_year}</Body>
    </Box>
  </Box>
)

const Invoice = ({ invoice: { createdAt, amount, number, invoicePdf, receiptPdf }, index }) => {
  const download = () => window.open(receiptPdf || invoicePdf)

  return (
    <Box fullWidth column>
      {index > 0 && <Box height={1} background="black" />}

      <Box p={12} fullWidth alignItems="center" justifyContent="space-between">
        <Box column gap={4} fullHeight >
          <Body>{format.money(amount, true)}</Body>
        </Box>

        <Box gap={16} alignItems="center">
          <Box column gap={4}>
            <Body align="end">{dayjs(createdAt).format('D MMM YY')}</Body>
            <Body align="end" size={12} bold>{number}</Body>
          </Box>

          <Box onClick={download} cursor="pointer">
            <Download fill="black" />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}